<template>
  <b-card class="rounded-lg">
    <report-header
      :title="$t('ledger_rep_projects')"
      :scope-label="scopeLabel"
      :can-company="canCompany"
      :company="company"
      @company="company = $event; load()"
      @print="printReport"
    />
    <div class="d-flex flex-wrap mb-1">
      <b-form-input v-model="from" type="date" class="mr-50 mb-50 ledger-report-date" />
      <b-form-input v-model="to" type="date" class="mr-50 mb-50 ledger-report-date" />
      <b-button size="sm" variant="primary" @click="load">{{ $t('ledger_assets_load') }}</b-button>
    </div>
    <div v-if="loading" class="text-center py-3"><b-spinner /></div>
    <template v-else-if="report">
      <article
        v-for="row in report.projects || []"
        :key="row.project_id"
        class="ledger-report-card"
        :class="{ 'text-danger': Number(row.profit) < 0 }"
      >
        <b-link :to="{ name: 'project_details', params: { id: row.project_id } }">
          {{ row.project_number }} — {{ row.name }}
        </b-link>
        <div class="ledger-num">{{ money(row.profit) }} ({{ row.margin_percent }}%)</div>
      </article>
      <div v-if="report.totals" class="font-weight-bold ledger-num mt-1">
        {{ $t('ledger_assets_total') }} {{ money(report.totals.profit) }}
      </div>
    </template>
  </b-card>
</template>

<script>
import { BCard, BFormInput, BButton, BSpinner, BLink } from 'bootstrap-vue'
import { getProjectProfitability } from '@/api/accounting/financialReports'
import { oneFrom } from '@/utils/ledger'
import ReportHeader from './ReportHeader.vue'
import reportMixin from './reportMixin'

export default {
  name: 'ProjectProfitability',
  components: { BCard, BFormInput, BButton, BSpinner, BLink, ReportHeader },
  mixins: [reportMixin],
  mounted() { this.load() },
  methods: {
    async load() {
      this.loading = true
      try {
        const res = await getProjectProfitability({ from: this.from, to: this.to, ...this.scopeParams })
        this.report = oneFrom(res)
      } catch (error) {
        this.toastError(error)
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

<style scoped>
.ledger-num { font-variant-numeric: tabular-nums; }
.ledger-report-date { max-width: 11rem; }
.ledger-report-card { border-bottom: 1px solid #eee; padding: 0.65rem 0; }
</style>
